import { render, staticRenderFns } from "./PaymentOption.vue?vue&type=template&id=13e16c2e&lang=pug"
import script from "./PaymentOption.vue?vue&type=script&lang=js"
export * from "./PaymentOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports